import React from "react";

import { IconButton } from "@mui/material";

import { ModalCardTitleContainer, ModalCardTitleLabel } from "./styled";

export {
  Modal as CustomerPortalModal,
  ModalBackdrop as CustomerPortalModalBackdrop,
  ModalCard as CustomerPortalModalCard,
  ModalCardContent as CustomerPortalModalCardContent,
  ModalCardActions as CustomerPortalModalActions,
} from "./styled";

const ModalCardCloseIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        d="M12 13.4L7.1 18.3C6.91667 18.4833 6.68334 18.575 6.4 18.575C6.11667 18.575 5.88334 18.4833 5.7 18.3C5.51667 18.1167 5.425 17.8833 5.425 17.6C5.425 17.3167 5.51667 17.0833 5.7 16.9L10.6 12L5.7 7.1C5.51667 6.91667 5.425 6.68334 5.425 6.4C5.425 6.11667 5.51667 5.88334 5.7 5.7C5.88334 5.51667 6.11667 5.425 6.4 5.425C6.68334 5.425 6.91667 5.51667 7.1 5.7L12 10.6L16.9 5.7C17.0833 5.51667 17.3167 5.425 17.6 5.425C17.8833 5.425 18.1167 5.51667 18.3 5.7C18.4833 5.88334 18.575 6.11667 18.575 6.4C18.575 6.68334 18.4833 6.91667 18.3 7.1L13.4 12L18.3 16.9C18.4833 17.0833 18.575 17.3167 18.575 17.6C18.575 17.8833 18.4833 18.1167 18.3 18.3C18.1167 18.4833 17.8833 18.575 17.6 18.575C17.3167 18.575 17.0833 18.4833 16.9 18.3L12 13.4Z"
        fill="#1D2939"
      />
    </svg>
  );
};

const ModalCardCloseButton = (props: React.HTMLProps<HTMLButtonElement>) => {
  const { onClick } = props;

  return (
    <IconButton color="secondary" aria-label="add an alarm" size="small" onClick={onClick}>
      <ModalCardCloseIcon width={24} height={24} />
    </IconButton>
  );
};

interface ModalCardTitleProps {
  children?: React.ReactNode;
  hasCloseButton?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const ModalCardTitle = ({ children, hasCloseButton, onClick, ...rest }: ModalCardTitleProps) => {
  return (
    <ModalCardTitleContainer {...rest}>
      <ModalCardTitleLabel>{children}</ModalCardTitleLabel>

      {hasCloseButton && <ModalCardCloseButton onClick={onClick} />}
    </ModalCardTitleContainer>
  );
};

export { ModalCardTitle as CustomerPortalModalTitle };
